import Vue from 'vue';

// HCPAY Components
import HomeCreditHeader from '@/components/homecredit_header.vue';
import HCPayFooter from '@/components/hcpay_footer.vue';
import BackToStore from '@/components/back_to_store.vue';
import CancelRequest from '@/components/cancel_request.vue';
import TransactionDetails from '@/components/transaction_details.vue';
import ApplyLoan from '@/components/apply_loan.vue';
import InputErrorMessage from '@/components/form/input_error_message.vue';
import InputPin from '@/components/form/input_pin.vue';
import AccountDropdown from '@/components/account_dropdown.vue';
import Timer from '@/components/timer.vue';
import TimerTwo from '@/components/timer-two.vue';
import MerchantDetails from '@/components/merchant_details.vue';
import PaymentSummary from '@/components/payment_summary.vue';
import Download from '@/components/download.vue';
import DownloadV2 from '@/components/download_v2.vue';
import WarningBar from '@/components/warning_bar.vue';
import InfoBar from '@/components/infobar.vue';
import OpenApp from '@/components/open_app.vue';
import LearnMore from '@/components/learn_more.vue';
import TermsAndConditions from '@/components/terms_and_conditions.vue';
import EmbedVideo from '@/components/embed_video.vue';
import EligibilityQualification from '@/views/eligibility-qualification.vue';
import PinImage from '@/components/pin_image.vue';

// OPG Components
import TransactionDetailsOpg from '@/components/opg/transaction_details.vue';
import TermsAndConditionsOpg from '@/components/opg/terms_and_conditions.vue';
import MerchantDetailsOpg from '@/components/opg/merchant_details.vue';
import PaymentSummaryOpg from '@/components/opg/payment_summary.vue';
import PaymentSummaryTwoOpg from '@/components/opg/payment_summary_two.vue';
import InstallmentPlan from '@/components/opg/installment_plan.vue';
import DownloadOpg from '@/components/opg/download_v2.vue';
import DownloadOpgV3 from '@/components/opg/v3/download_v3.vue';
import LearnMoreOpg from '@/components/opg/learn_more.vue';
import CancelRequestOpg from '@/components/opg/cancel_request_opg.vue';

// Lazada Components
import LazadaBanners from '@/components/lazada/lazada-banners.vue';
import LazadaMerchantDetails from '@/components/lazada/merchant-details.vue';
import LazadaPaymentSummary from '@/components/lazada/payment-summary.vue';
import LazadaDownload from '@/components/lazada/download.vue';
import LazadaCancelRequest from '@/components/lazada/cancel_request.vue';
import LazadaReturn from '@/components/lazada/return.vue';
import LazadaFAQs from '@/components/lazada/faqs.vue';
import LazadaInformation from '@/components/lazada/information.vue';

Vue.component('homecredit-header', HomeCreditHeader);
Vue.component('hcpay-footer', HCPayFooter);
Vue.component('back-to-store', BackToStore);
Vue.component('cancel-request', CancelRequest);
Vue.component('transaction-details', TransactionDetails);
Vue.component('apply-loan', ApplyLoan);
Vue.component('input-error-message', InputErrorMessage);
Vue.component('input-pin', InputPin);
Vue.component('account-dropdown', AccountDropdown);
Vue.component('timer', Timer);
Vue.component('timer-two', TimerTwo);
Vue.component('merchant-details',MerchantDetails);
Vue.component('payment-summary', PaymentSummary);
Vue.component('download', Download);
Vue.component('downloadV2', DownloadV2);
Vue.component('warning-bar', WarningBar);
Vue.component('info-bar', InfoBar);
Vue.component('open-app', OpenApp);
Vue.component('learn-more', LearnMore);
Vue.component('terms-and-conditions', TermsAndConditions);
Vue.component('embed-video', EmbedVideo);
Vue.component('eligibility-qualification', EligibilityQualification);
Vue.component('pin-image', PinImage);

/** OPG */
Vue.component('transaction-details-opg', TransactionDetailsOpg);
Vue.component('terms-and-conditions-opg', TermsAndConditionsOpg);
Vue.component('merchant-details-opg', MerchantDetailsOpg);
Vue.component('payment-summary-opg', PaymentSummaryOpg);
Vue.component('payment-summary-two-opg', PaymentSummaryTwoOpg);
Vue.component('installment-plan', InstallmentPlan);
Vue.component('download-opg', DownloadOpg);
Vue.component('download-opg-v3', DownloadOpgV3);
Vue.component('learn-more-opg', LearnMoreOpg);
Vue.component('cancel-request-opg', CancelRequestOpg);

/** Lazada */
Vue.component('lazada-banners', LazadaBanners);
Vue.component('lazada-merchant-details', LazadaMerchantDetails);
Vue.component('lazada-payment-summary', LazadaPaymentSummary);
Vue.component('lazada-download', LazadaDownload);
Vue.component('lazada-cancel-request', LazadaCancelRequest);
Vue.component('lazada-return', LazadaReturn);
Vue.component('lazada-faqs', LazadaFAQs);
Vue.component('lazada-information', LazadaInformation);